export default {"src":"https://static.eleduck.com/_next/static/media/logo-upright.23fafe69.svg","height":232,"width":507,"blurWidth":0,"blurHeight":0};